import styled from "styled-components";

export const ButtonContainer = styled.button`
  border: ${({ theme }) => theme.button.border.base};
  text-transform: none;
  color: ${({ theme }) => theme.button.font.primary};
  font-weight: ${({ theme }) => theme.constants.FONT_WEIGHT_400};
  border-radius: ${({ theme }) => theme.button.radius};
  background: ${({ theme }) => theme.button.bg.primary};
  padding: ${({ theme }) => theme.button.padding.base};

  &.button-primary {
    background-color: ${({ theme }) => theme.button.bg.primary};
    &:hover {
      background-color: ${({ theme }) => theme.button.hover.color};
    }
    font-family: "Geist", sans-serif;
  }
  &.button-secondary {
    background: #fff;
    color: ${({ theme }) => theme.global.color.auth};
    padding: 10px 14px;
    border-radius: 8px;
    border: 1px solid #d5d7da;
    font-family: "Geist", sans-serif;
  }

  &.button-tertiary {
    background: ${({ theme }) => theme.button.bg.secondary};
    color: ${({ theme }) => theme.button.font.secondary};
  }

  &.button-outlined {
    background-color: transparent;
    border: 1px solid ${({ theme }) => theme.button.bg.primary};
    color: ${({ theme }) => theme.button.bg.primary};
    &:hover {
      background-color: transparent;
    }
  }

  &.button-options {
    background-color: ${({ theme }) => theme.input.bg.quaternary};
    color: #717184;
    font-weight: 500;
    text-align: left;
    text-wrap: nowrap;

    &:hover {
      background-color: ${({ theme }) => theme.input.bg.quaternary};
    }

    &.selected {
      background-color: ${({ theme }) => theme.button.bg.primary};
      color: #fff;
    }
  }

  &.button-small {
    height: fit-content;
    width: fit-content;
    font-size: 14px;
    padding: ${({ theme }) => theme.button.padding.base};
  }
  &.button-medium {
    font-size: 13px;
    padding: ${({ theme }) => theme.button.padding.base};
  }
  &.button-large {
    font-size: 14px;
    padding: ${({ theme }) => theme.button.padding.base};
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &.button-xl {
    border-radius: 55px;
    padding: 10px 32px;
    font-size: 14px;
    font-weight: 500;

    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 173px;
  }

  @media (max-width: 767px) {
    &.button-options {
      text-wrap: wrap;
    }
  }
`;
